module.exports = __webpack_public_path__ + "static/media/lc.c056c2a7.svg";